import type {
  Basket,
  ServicesPreferencesModalProps,
} from '@wix/bookings-services-preferences-modal/types';
import { useStyles } from '@wix/tpa-settings/react';
import {
  useBi,
  useEnvironment,
  useExperiments,
  useTranslation,
} from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import React from 'react';
import { DialogViewModel } from '../../../../service-page-view-model/dialogViewModel/dialogViewModel';
import stylesParams from '../../stylesParams';
import { useServicePageActions } from '../useServicePageActions';
import { servicesPreferencesModalKeysMap as servicesPreferencesModalFormatterKeysMap } from './constants';
import { classes } from './Dialog.st.css';

export type DialogProps = {
  viewModel: DialogViewModel;
};

const ServicesPreferencesModal: React.FC<ServicesPreferencesModalProps> =
  loadable(() => import('@wix/bookings-services-preferences-modal'));

export const Dialog: React.FC<DialogProps> = ({ viewModel }) => {
  const { experiments } = useExperiments();
  const { closeDialog, onPreferencesModalServiceSelected, navigateToCalendar } =
    useServicePageActions();
  const { t } = useTranslation();
  const { isMobile, isRTL, isCssPerBreakpoint } = useEnvironment();
  const styles = useStyles();
  const biLogger = useBi();

  if (viewModel.isOpen) {
    return (
      <ServicesPreferencesModal
        className={classes.servicesPreferencesModal}
        {...viewModel.data!}
        widgetStyles={{
          primaryColor: styles.get(stylesParams.bodyButtonBackgroundColor)
            .value,
        }}
        t={t}
        onConfirm={(basket: Basket) => {
          closeDialog();
          navigateToCalendar({ basket });
        }}
        onClose={closeDialog}
        onServiceSelected={onPreferencesModalServiceSelected}
        isMobile={isMobile}
        isRTL={isRTL}
        isCssPerBreakpoint={isCssPerBreakpoint}
        biLogger={biLogger}
        formatterKeysMap={servicesPreferencesModalFormatterKeysMap}
        experiments={experiments}
        openedBy="service_page"
      />
    );
  }

  return null;
};
